import { useScreenSize } from '@hooks';
import { Button, theme } from '@styles';
import { func, string } from 'prop-types';
import React from 'react';

import { Icon } from '../Icon';
import { actionButtonLayoutByVariant } from './ActivityHeader.layoutProps';

const ActivityButton = ({ onClick, onHover, variant }) => {
  const { isTabletLG } = useScreenSize();
  const layout = actionButtonLayoutByVariant[variant];

  return (
    <Button
      backgroundColor={theme.colors.white[10]}
      border={0}
      height={40}
      onClick={isTabletLG ? onClick : null}
      onMouseOut={onHover(false)}
      onMouseOver={onHover(true)}
      opacity={0.8}
      width={40}
    >
      <Icon color={theme.colors.white[10]} SVG={layout.svg} />
    </Button>
  );
};

ActivityButton.propTypes = {
  onClick: func.isRequired,
  onHover: func.isRequired,
  variant: string.isRequired,
};

export default ActivityButton;
